// extracted by mini-css-extract-plugin
module.exports = {"panel":"live-conversations__components__panel","panelRow":"live-conversations__components__panelRow"};